export const DEFAULT_CONTACTS_LIMIT = 20;

// Minimum digits required to show typed number as option
export const MIN_PHONE_DIGITS = 3;

// Performance requirement for showing typed option
export const TYPED_OPTION_DELAY_MS = 300;

export const CONTACT_TYPES = {
  INTERNAL: 'internal-contact',
  EXTERNAL: 'external-contact',
  UNSAVED: 'unsaved-contact',
} as const;

export const CONTACT_TYPE_LABELS = {
  'external-contact': 'external',
  'internal-contact': 'internal',
  'unsaved-contact': 'phone number',
} as const;

export const TOOLTIP_MESSAGES = {
  'external-contact': 'Only external contacts can be grouped together',
  'internal-contact': 'Only internal contacts can be grouped together',
  'unsaved-contact': 'Only external contacts can be grouped together',
  'mixed-internal-first': 'Only internal contacts can be grouped',
  'already-selected': 'This number is already selected',
} as const;

export const MIXED_CONTACTS_MESSAGE = 'You cannot mix internal and external contacts in the same conversation';
